export default "__VITE_ASSET__CVVZzLXC__"